import { IApiRequest, IApiResponse, ICalendarSet } from "@miplatform/types";
import { TASK_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_CALENDAR_SETS = `${TASK_SERVICE}/calendar-sets`;

export const calendarSets = {
  getAll: async ({
    filters,
    sort,
    params,
    signal,
    toastMessageConfig,
  }: IApiRequest = {}): IApiResponse<ICalendarSet[]> => {
    const options = await apiOptions({
      url: API_CALENDAR_SETS,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  getMyCalendarSets: async ({
    filters,
    sort,
    params,
    signal,
    toastMessageConfig,
  }: IApiRequest = {}): IApiResponse<ICalendarSet[]> => {
    const options = await apiOptions({
      url: `${TASK_SERVICE}/me/calendar-sets`,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  getById: async ({ id, signal, toastMessageConfig }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: `${API_CALENDAR_SETS}/${id}`,
      method: "get",
      signal,
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  create: async ({ data, signal, toastMessageConfig }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: API_CALENDAR_SETS,
      method: "post",
      signal,
      data,
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  update: async ({
    id,
    data,
    signal,
    toastMessageConfig,
  }: IApiRequest<Partial<ICalendarSet>> = {}): IApiResponse<ICalendarSet> => {
    const options = await apiOptions({
      url: `${API_CALENDAR_SETS}/${id}`,
      method: "patch",
      signal,
      data,
    });

    const response = await apiRequest(options, toastMessageConfig);

    return response;
  },
  delete: async ({
    id,
    data,
    signal,
    toastMessageConfig,
  }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: `${API_CALENDAR_SETS}/${id}`,
      method: "delete",
      signal,
      data,
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  updateStatus: async ({
    id,
    data,
    signal,
    toastMessageConfig,
  }: IApiRequest = {}): IApiResponse<ICalendarSet> => {
    const options = await apiOptions({
      url: `${API_CALENDAR_SETS}/status/${id}`,
      method: "patch",
      signal,
      data,
    });

    const response = await apiRequest(options, toastMessageConfig);

    return response;
  },
  getAssignableUsersAvailableTime: async ({
    id,
    signal,
    toastMessageConfig,
    params,
  }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: `${API_CALENDAR_SETS}/${id}/assignable-users`,
      method: "get",
      signal,
      params,
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  getLockStatus: async ({ id, signal }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: `${API_CALENDAR_SETS}/${id}/lock-status`,
      method: "get",
      signal,
    });

    const response = await apiRequest(options);
    return response;
  },
  acquireLock: async ({ id, signal }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: `${API_CALENDAR_SETS}/${id}/lock`,
      method: "post",
      signal,
    });

    const response = await apiRequest(options);
    return response;
  },
};
